export default (state = '', action)=>{
    //TODO legacy?
    return state;
};
